
import { defineComponent } from "vue";

export default defineComponent({
  name: "helpArticle",
  props: {
    article: Object
  }
});
